import React, { useEffect, useState, useRef } from "react";
import { default as LeftOverlay } from "./sim-components/LeftOverlay";
import { default as RightOverlay } from "./sim-components/RightOverlay";
import { default as FullScreenColumns } from "./sim-components/FullScreenColumns";
import { default as CenterImage } from "./sim-components/CenterImage";
import { default as Arrows } from "./sim-components/Arrows";
import { default as CornerTitle } from "./sim-components/CornerTitle";
import { default as Backgrounds } from "./sim-components/Backgrounds";
import { default as VideoBG } from "./sim-components/VideoBG";
import { default as Steps } from "./sim-components/Steps";
import { default as Disclaimer } from "./Disclaimer";
import { default as Body } from "./sim-components/Body";
import { default as Footer } from "./sim-components/Footer";
import { default as Title } from "./sim-components/Title";
import { default as CenterFc } from "./sim-components/CenterFc";
import "./SimulatorInfo.css";
import Emulator from "./Emulator";
import SvgLines from "react-mt-svg-lines";
import { StarTwoTone } from "@material-ui/icons";

import Sim from "./Sim";

export default function SimulatorInfo({
  pageJSON,
  setPage,
  prevTopic,
  nextTopic,
  emulatorStep,
  setEmulatorStep,
  currentScreen,
  setCurrentScreen,
  page,
  isAndroid,
}) {
  const [simPageNum, setSimPageNum] = useState(0);
  const [singleScreenStep, setSingleScreenStep] = useState(0);
  const [isSingleStepScreen, setIsSingleStepScreen] = useState(false);
  const [isEmulatorStep, setIsEmulatorStep] = useState(false);
  const [singleScreenStepLength, setSingleScreenStepLength] = useState();
  const [totalSteps, setTotalSteps] = useState();

  useEffect(() => {
    setEmulatorStep(0);
  }, [pageJSON]);

  const switchScreens = () => {
    if (isSingleStepScreen && singleScreenStep < singleScreenStepLength - 1) {
      setSingleScreenStep((prevState) => {
        prevState++;

        return prevState;
      });
    } else if (isEmulatorStep && emulatorStep < totalSteps - 1) {
      setEmulatorStep((prevState) => {
        prevState++;

        return prevState;
      });
    } else if (pageJSON.length - 1 > simPageNum) {
      setSimPageNum((prevState) => {
        prevState++;
        setEmulatorStep(0);

        return prevState;
      });
    } else {
      setPage(nextTopic);
    }
  };

  const data = pageJSON[simPageNum].content_data;
  const pgData = pageJSON[simPageNum];
  const simRef = useRef();
  const emBezRef = useRef();
  const [width, setWidth] = useState(
    simRef.current && simRef.current.getBoundingClientRect().width
  );
  // const [emWidth, setEmWidth]  = useState(emBezRef.current && emBezRef.current.getBoundingClientRect().width);
  const [height, setHeight] = useState(
    simRef.current && simRef.current.getBoundingClientRect().height
  );

  const handleWindowResize = () => {
    if (simRef.current) {
      setWidth(simRef.current.getBoundingClientRect().width);
      setHeight(simRef.current.getBoundingClientRect().height);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    if (simRef.current) {
      setWidth((p) => (p = simRef.current.getBoundingClientRect().width));
      setHeight((p) => (p = simRef.current.getBoundingClientRect().height));
    }
  }, [page, simRef && simRef.current, emulatorStep]);
  const [mwidth, setMWidth] = useState(
    emBezRef.current ? emBezRef.current.getBoundingClientRect().width : "0"
  );
  useEffect(() => {
    if (emBezRef.current) {
      setMWidth(emBezRef.current.getBoundingClientRect().width);
    }
  }, [emBezRef && emBezRef.current, width, height]);
  return (
    <>
      {pgData.type === "flexed" ? (
        <>
          <div
            className="flexed-container"
            // style={
            //   !pgData.meta
            //     ? {
            //         backgroundImage: `url(${pgData.background_image})`,
            //         backgroundPositionY: "170px !important",
            //         backgroundRepeat: "no-repeat",
            //         ...pgData.background_styles,
            //       }
            //     : null
            // }
          >
            <Backgrounds data={pgData} />
            {(pgData.background_image === "iot-video" ||
              pgData.background_image === "uei-video") &&
              simPageNum === 0 && <VideoBG type={pgData.background_image} />}
            {pgData.meta && pgData.meta === "sound" && (
              <>
                {pgData.over_animation && (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      position: "absolute",
                      right: 0,
                      bottom: 0,
                      zIndex: 2,
                    }}
                  >
                    <img
                      src="./images/sound.svg"
                      alt={"sound wave"}
                      style={{
                        position: "absolute",
                        left: "0px",
                        bottom: "0px",
                        width: "calc(100% + 100px)",
                        height: "auto",
                        opacity: 0,
                        animation: "1.3s fadeIn 1s forwards",
                      }}
                    />
                  </div>
                )}
              </>
            )}

            <div className="flexed-overlay">
              {((data && data.left_overlay_color && !pgData.first_over) ||
                (pgData.first_over && emulatorStep === 0)) && (
                <div
                  className="fol"
                  style={{
                    opacity: data.fade_in_delay ? 0 : 1,
                    animation: data.fade_in_delay
                      ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                      : null,
                    backgroundColor: data.left_overlay_color,
                  }}
                ></div>
              )}
              {data && data.right_overlay_color && (
                <div
                  className="for"
                  style={
                    data.right_overlay_color &&
                    data.right_overlay_color.includes("linear-gradient")
                      ? {
                          opacity: data.fade_in_delay ? 0 : 1,
                          animation: data.fade_in_delay
                            ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                            : null,
                          background: data.right_overlay_color,
                          zIndex: "1",
                        }
                      : {
                          opacity: data.fade_in_delay ? 0 : 1,
                          animation: data.fade_in_delay
                            ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                            : null,
                          backgroundColor: data.right_overlay_color
                            ? data.right_overlay_color
                            : null,
                        }
                  }
                ></div>
              )}
            </div>

            <div className="flexed-header">
              {data.title && data.title.main_title ? (
                <Title myJSON={data} emulatorStep={emulatorStep} />
              ) : null}
              {data && data.corner_title && (
                <div
                  className="	flexed-title"
                  id="right-header"
                  style={{
                    width: "100%",
                    // backgroundColor: "rgb(210,35,78)",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <img
                    className="flexed-title-right-letter"
                    alt=""
                    src={data.corner_title.first_letter_src}
                  />
                  <h3
                    className="flexed-title-right"
                    style={{
                      textAlign: "center",
                      marginBottom: window.navigator.platform.includes("Win")
                        ? "12px"
                        : "6px",
                      marginLeft: "2px",
                      color: "#c20839",
                      fontFamily: "LG_Smart_Bold",
                    }}
                  >
                    {data.corner_title.title}
                  </h3>
                  {data.corner_title.second_half ? (
                    <>
                      <div
                        className="flexed-title-right"
                        style={{
                          backgroundColor: "grey",
                          width: "1.2px",
                          height: "40px",
                          margin: "0 15px",
                        }}
                      ></div>
                      <h3
                        className="flexed-title-right"
                        style={{
                          color: data.corner_title.second_half_color
                            ? data.corner_title.second_half_color
                            : "rgb(255,255,255)",
                          fontFamily: "LG_Smart_Bold",
                          margin: "0 40px 0 0",
                        }}
                      >
                        {data.corner_title.second_half}
                      </h3>
                    </>
                  ) : null}
                </div>
              )}
            </div>

            {pgData.center_image_data && pgData.center_image_data.tv_screen ? (
              <div
                style={
                  emulatorStep &&
                  pageJSON &&
                  simPageNum &&
                  setTotalSteps &&
                  data &&
                  data.steps &&
                  data.steps[emulatorStep].custom_step
                    ? {
                        height:
                          data.steps && data.steps[emulatorStep].full
                            ? "100%"
                            : "calc(100% - 140px)",
                        width: "100% ",
                        marginTop:
                          data.steps && data.steps[emulatorStep].full
                            ? 0
                            : "70px",
                        pointerEvents: "all",
                        zIndex: "1",
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${
                          data.steps &&
                          data.steps[emulatorStep].custom_step.image
                        })`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                        // backgroundColor:"blue"
                      }
                    : {
                        height:
                          isAndroid &&
                          !window.matchMedia("(display-mode: standalone)")
                            .matches
                            ? "87%"
                            : "100%",
                        width: "100%",
                        position: "relative",
                        zIndex: pgData.center_image_data.in_front ? "70" : "1",
                        top: pgData.center_image_data.top
                          ? pgData.center_image_data.top
                          : "0px",
                      }
                }
              >
                {/* <div
                  ref={simRef}
                  className="simref-container"
                  style={
                    {
                      position: "absolute",
                      height: "65%",
                      width: "100% ",
                      pointerEvents: "all",
                      zIndex: "0",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      // backgroundColor:"pink",
                    }
                  }
                > */}
                <Sim
                  mwidth={mwidth}
                  isAndroid={isAndroid}
                  height={height}
                  topMove={
                    pgData.center_image_data.adjustTopMove ? true : false
                  }
                  myScreen={
                    data.steps
                      ? data.steps[emulatorStep].screen
                      : pgData.center_image_data.screen
                  }
                  hideButtons={pgData.center_image_data.hide_buttons}
                  transitionSim={pgData.center_image_data.show_transition}
                  fadeBetween={pgData.center_image_data.fade}
                  highlighted={
                    data.steps && data.steps[emulatorStep].highlighted
                  }
                  customButton={
                    data.steps && data.steps[emulatorStep].custom_button
                  }
                  hideScreenBtns={
                    data.steps && data.steps[emulatorStep].hide_screen_btns
                      ? true
                      : false
                  }
                  hideRemoteBtns={
                    data.steps && data.steps[emulatorStep].hide_remote_btns
                      ? true
                      : false
                  }
                  isMovedDown={Boolean(pgData.center_image_data.top)}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  isSingleStepScreen={isSingleStepScreen}
                  setIsSingleStepScreen={setIsSingleStepScreen}
                  setSimPageNum={setSimPageNum}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  totalSteps={totalSteps}
                  switchScreens={switchScreens}
                  pageJSON={pageJSON}
                  simPageNum={simPageNum}
                  setIsEmulatorStep={setIsEmulatorStep}
                  setTotalSteps={setTotalSteps}
                  page={page}
                  emBezRef={emBezRef}
                />
                {/* <Emulator
                  mwidth={mwidth}
                    isAndroid={isAndroid}
                    height={height}
                    myScreen={
                      data.steps
                        ? data.steps[emulatorStep].screen
                        : pgData.center_image_data.screen
                    }
                    hideButtons={pgData.center_image_data.hide_buttons}
                    transitionSim={pgData.center_image_data.show_transition}
                    highlighted={
                      data.steps && data.steps[emulatorStep].highlighted
                    }
                    customButton={
                      data.steps && data.steps[emulatorStep].custom_button
                    }
                    hideScreenBtns={
                      data.steps && data.steps[emulatorStep].hide_screen_btns
                        ? true
                        : false
                    }
                    hideRemoteBtns={
                      data.steps && data.steps[emulatorStep].hide_remote_btns
                        ? true
                        : false
                    }
                    currentScreen={currentScreen}
                    setCurrentScreen={setCurrentScreen}
                    isSingleStepScreen={isSingleStepScreen}
                    setIsSingleStepScreen={setIsSingleStepScreen}
                    setSimPageNum={setSimPageNum}
                    emulatorStep={emulatorStep}
                    setEmulatorStep={setEmulatorStep}
                    totalSteps={totalSteps}
                    switchScreens={switchScreens}
                    pageJSON={pageJSON}
                    simPageNum={simPageNum}
                    setIsEmulatorStep={setIsEmulatorStep}
                    setTotalSteps={setTotalSteps}
                    page={page}
                    emBezRef={emBezRef}
                  /> */}

                {/* </div> */}
                <div
                  style={
                    data.steps && data.steps[emulatorStep].full
                      ? {
                          position: "absolute",
                          bottom: "20%",
                          // left: `calc(50% - ${mwidth / 2}px`,
                          flex: 1,
                          height: "45%",
                          width: "100%",
                        }
                      : { flex: 1, height: "14%" }
                  }
                ></div>
              </div>
            ) : null}
            <div
              className="flexed-inner"
              style={{ pointerEvents: data.steps ? "none" : "all" }}
            >
              <div
                className="flexed-content"
                style={data.content_margin ? { ...data.content_margin } : {}}
              >
                <div
                  className={
                    !data.small_mobile ? "left-fc" : "left-fc left-fc-mobile"
                  }
                  style={{
                    opacity: data.fade_in_delay ? 0 : 1,
                    animation: data.fade_in_delay
                      ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                      : null,
                    width: data.wtype === "wide" ? "calc(50% - 30px)" : "40%",
                  }}
                >
                  {data.body ? (
                    <Body
                      side="left"
                      page={page}
                      myJSON={data}
                      emulatorStep={emulatorStep}
                      setIsSingleStepScreen={setIsSingleStepScreen}
                      setSingleScreenStepLength={setSingleScreenStepLength}
                      singleScreenStep={singleScreenStep}
                    />
                  ) : null}
                  {data.left_image && (
                    <div
                      className=""
                      style={{
                        marginTop: "10px",
                        height:
                          data.left_image.component === "change-height"
                            ? data.left_image.height
                            : "auto",
                        width:
                          data.left_image.component === "change-height"
                            ? "100%"
                            : "90%",
                        position: "relative",
                        transformOrigin: data.left_image.transform_origin
                          ? data.left_image.transform_origin
                          : null,
                        maxWidth: "700px",
                        top: data.left_image.top_position
                          ? data.left_image.top_position
                          : "0px",
                        left: data.left_image.left_position
                          ? data.left_image.left_position
                          : "0px",
                      }}
                    >
                      <img
                        alt="tv-screen"
                        src={data.left_image.src}
                        className={
                          data.left_image.push_left
                            ? "alter-position-left"
                            : null
                        }
                        style={{
                          height:
                            data.left_image.component === "change-height"
                              ? data.left_image.height
                              : "auto",
                          width:
                            data.left_image.component === "change-height"
                              ? "100%"
                              : "99.6%",
                          position: "absolute",
                          zIndex: "199",
                          top: data.left_image.top
                            ? data.left_image.top + 9
                            : null,
                          left: data.left_image.left
                            ? data.left_image.left
                            : null,
                          margin: data.left_image.margin
                            ? data.left_image.margin
                            : null,
                        }}
                      />
                      {data.left_image.changing_screens
                        ? data.left_image.changing_screens.map((src, i) => {
                            const delay = `${0.5 + i / 2}s`;
                            return (
                              <img
                                alt="tv-screen"
                                src={src}
                                className={
                                  data.left_image.push_left
                                    ? "alter-position-left"
                                    : null
                                }
                                style={{
                                  height: "auto",
                                  width: "99.6%",
                                  position: "absolute",
                                  zIndex: "199",
                                  top: data.left_image.top
                                    ? data.left_image.top + 9
                                    : null,
                                  left: data.left_image.left
                                    ? data.left_image.left
                                    : null,
                                  margin: data.left_image.margin
                                    ? data.left_image.margin
                                    : null,
                                  opacity: "0",
                                  animationDuration: "0.5s",
                                  animationFillMode: "forwards",
                                  animationName: "fadeIn",
                                  animationDelay: delay,
                                }}
                              />
                            );
                          })
                        : null}

                      {data.left_image.bezel ? (
                        <img
                          className={
                            data.left_image.push_left
                              ? "alter-position-left"
                              : null
                          }
                          alt="bezel"
                          src={data.left_image.bezel}
                          style={{
                            height: "auto",
                            width: "100%",
                            position: "absolute",
                            top: data.left_image.top,
                            left: data.left_image.left,
                            zIndex: "200",
                          }}
                        />
                      ) : null}
                    </div>
                  )}

                  {/* {data.footer ? (
									<Footer
										myJSON={data.footer}
										singleScreenStep={singleScreenStep}
										setIsSingleStepScreen={setIsSingleStepScreen}
										setSingleScreenStepLength={setSingleScreenStepLength}
										isSingleStepScreen={isSingleStepScreen}
									/>
								) : null} */}
                </div>
                {data.right_content ? (
                  <div
                    className="right-fc"
                    style={{
                      opacity: data.fade_in_delay ? 0 : 1,
                      animation: data.fade_in_delay
                        ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                        : null,
                    }}
                  >
                    <Body side="right" page={page} myJSON={pgData} />
                  </div>
                ) : null}
                {pgData.center_image_data &&
                !pgData.center_image_data.behind_content ? (
                  <CenterFc pageJSON={pageJSON} simPageNum={simPageNum} />
                ) : null}
              </div>
              <div
                className="flexed-footer"
                style={{
                  position: "fixed",
                  bottom:
                    data.footer && data.footer.bottom
                      ? data.footer.bottom
                      : "0px",
                  height: "5%",
                }}
              >
                <div
                  className="ff-left"
                  style={{
                    opacity: data.fade_in_delay ? 0 : 1,
                    animation: data.fade_in_delay
                      ? `0.5s fadeIn ${data.fade_in_delay} forwards`
                      : null,
                  }}
                >
                  {data.footer && data.footer.type === "left" && (
                    <p
                      className="footer-text"
                      style={{
                        margin: data.footer.margin,
                        marginLeft: 0,
                        width: "80%",
                        color: data.footer.color ? data.footer.color : null,
                      }}
                      dangerouslySetInnerHTML={{ __html: data.footer.text }}
                    ></p>
                  )}
                </div>
                <div className="ff-right">
                  {data.footer && data.footer.type === "right" && (
                    <p
                      className="footer-text"
                      style={{
                        color: data.footer.color ? data.footer.color : null,
                        width: "80%",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: isSingleStepScreen
                          ? data.footer.text[singleScreenStep]
                          : data.footer.text,
                      }}
                    ></p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!data.steps ||
          (data.steps && !data.steps[emulatorStep].hide_arrows) ? (
            <Arrows
              prevTopic={prevTopic}
              singleScreenStep={singleScreenStep}
              singleScreenStepLength={singleScreenStepLength}
              isSingleStepScreen={isSingleStepScreen}
              simPageNum={simPageNum}
              isEmulatorStep={isEmulatorStep}
              emulatorStep={emulatorStep}
              setSingleScreenStep={setSingleScreenStep}
              setEmulatorStep={setEmulatorStep}
              setSimPageNum={setSimPageNum}
              setPage={setPage}
              switchScreens={switchScreens}
              totalSteps={totalSteps}
            />
          ) : null}
        </>
      ) : (
        <div className="simulator-info-page-container">
          {data && data.left_overlay_color ? (
            <>
              <LeftOverlay
                pageJSON={pageJSON}
                simPageNum={simPageNum}
                singleScreenStep={singleScreenStep}
                isSingleStepScreen={isSingleStepScreen}
                setIsSingleStepScreen={setIsSingleStepScreen}
                setSingleScreenStepLength={setSingleScreenStepLength}
                emulatorStep={emulatorStep}
              />
            </>
          ) : null}

          {pgData.center_image_data &&
          !pgData.center_image_data.behind_content ? (
            <CenterImage pageJSON={pageJSON} simPageNum={simPageNum} />
          ) : null}

          <div
            className="right-half-info-page-container"
            style={
              pgData.background_color &&
              pgData.background_color.includes("linear-gradient")
                ? {
                    background: pgData.background_color,
                    zIndex: "1",
                  }
                : {
                    backgroundColor: pgData.background_color
                      ? pgData.background_color
                      : "white",
                  }
            }
          >
            <Backgrounds data={pgData} />
            {(pgData.background_image === "iot-video" ||
              pgData.background_image === "uei-video") &&
              simPageNum === 0 && <VideoBG type={pgData.background_image} />}
            {data && data.corner_title ? <CornerTitle data={data} /> : null}
            {data && data.full_width ? <FullScreenColumns data={data} /> : null}
            {pgData.center_image_data && pgData.center_image_data.tv_screen ? (
              <div
                style={
                  emulatorStep &&
                  pageJSON &&
                  simPageNum &&
                  setTotalSteps &&
                  data &&
                  data.steps &&
                  data.steps[emulatorStep].custom_step
                    ? {
                        position: "relative",
                        height: "100%",
                        width: "100% ",
                        marginTop: "-70px",
                        pointerEvents: "all",
                        zIndex: "999",
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${
                          data.steps &&
                          data.steps[emulatorStep].custom_step.image
                        })`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                      }
                    : {
                        position: "relative",
                        height: "100%",
                        width: "100% ",
                        marginTop: "-70px",
                        pointerEvents: "all",
                        zIndex: "999",
                        display: "flex",
                        flexDirection: "column",
                      }
                }
              >
                <Emulator
                  isAndroid={isAndroid}
                  myScreen={
                    data.steps
                      ? data.steps[emulatorStep].screen
                      : pgData.center_image_data
                      ? pgData.center_image_data.screen
                      : null
                  }
                  hideButtons={pgData.center_image_data.hide_buttons}
                  transitionSim={pgData.center_image_data.show_transition}
                  highlighted={
                    data.steps && data.steps[emulatorStep].highlighted
                  }
                  customButton={
                    data.steps && data.steps[emulatorStep].custom_button
                  }
                  hideScreenBtns={
                    data.steps && data.steps[emulatorStep].hide_screen_btns
                      ? true
                      : false
                  }
                  hideRemoteBtns={
                    data.steps && data.steps[emulatorStep].hide_remote_btns
                      ? true
                      : false
                  }
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  isSingleStepScreen={isSingleStepScreen}
                  setIsSingleStepScreen={setIsSingleStepScreen}
                  setSimPageNum={setSimPageNum}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  totalSteps={totalSteps}
                  switchScreens={switchScreens}
                  pageJSON={pageJSON}
                  simPageNum={simPageNum}
                  setIsEmulatorStep={setIsEmulatorStep}
                  setTotalSteps={setTotalSteps}
                  page={page}
                />
              </div>
            ) : null}

            {pgData.over_animation && (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  position: "absolute",
                  right: 0,
                  bottom: 0,
                  zIndex: 999,
                }}
              >
                <img
                  src="./images/sound.svg"
                  alt={"sound wave"}
                  style={{
                    position: "fixed",
                    left: "60px",
                    top: "10%",
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    animation: "1s fadeIn 1.5s forwards",
                  }}
                />
              </div>
            )}

            {data && data.right_overlay_color ? (
              <RightOverlay
                pageJSON={pageJSON}
                simPageNum={simPageNum}
                singleScreenStep={singleScreenStep}
                setIsSingleStepScreen={setIsSingleStepScreen}
                setSingleScreenStepLength={setSingleScreenStepLength}
              />
            ) : null}
            {pgData.center_image_data &&
            pgData.center_image_data.behind_content &&
            !pgData.center_image_data.tv_screen ? (
              <CenterImage pageJSON={pageJSON} simPageNum={simPageNum} />
            ) : null}
          </div>
          {!data.steps ||
          (data.steps && !data.steps[emulatorStep].hide_arrows) ? (
            <Arrows
              prevTopic={prevTopic}
              singleScreenStep={singleScreenStep}
              singleScreenStepLength={singleScreenStepLength}
              isSingleStepScreen={isSingleStepScreen}
              simPageNum={simPageNum}
              isEmulatorStep={isEmulatorStep}
              emulatorStep={emulatorStep}
              setSingleScreenStep={setSingleScreenStep}
              setEmulatorStep={setEmulatorStep}
              setSimPageNum={setSimPageNum}
              setPage={setPage}
              switchScreens={switchScreens}
              totalSteps={totalSteps}
            />
          ) : null}
          {pgData.bottom_banner ? (
            <div
              style={{
                backgroundImage: pgData.bottom_banner.image,
                height: pgData.bottom_banner.img_height,
                width: pgData.bottom_banner.img_width,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                zIndex: "50",
                position: pgData.bottom_banner.position,
                bottom: pgData.bottom_banner.bottom,
                left: pgData.bottom_banner.left,
              }}
            ></div>
          ) : null}
        </div>
      )}
      {emulatorStep &&
      page &&
      data.steps &&
      !data.steps[emulatorStep].custom_step ? (
        <Disclaimer remote={true} page={page} step={emulatorStep} />
      ) : data.steps && !data.steps[emulatorStep].custom_step ? (
        <Disclaimer
          page={page}
          step={emulatorStep}
          noScreen={false}
          remote={true}
        />
      ) : data.steps && data.steps[emulatorStep].custom_step ? (
        <Disclaimer
          page={page}
          step={emulatorStep}
          noScreen={true}
          remote={false}
        />
      ) : null}
    </>
  );
}
